// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2dJ54","footer":"ModalCreateQualiphyProcedure_footer__1h9Cc","additionData":"ModalCreateQualiphyProcedure_additionData__3peyu"};